<div class="vm-radio-container">
  <input
    type="radio"
    id="{{ productId }}"
    name="{{ name }}"
    (change)="click(productId)"
    [checked]="isChecked"
    value="{{ productId }}"
  />
  <label class="label-text Body-Small-Book" for="{{ productId }}">
    <div class="sr-only" [innerHTML]="alt + ' toggle'"></div>
    <i class="far fa-fw fa-check check"></i>
  </label>
</div>
